import React from "react";
import { Link } from "react-router-dom";
import whatsapp from "../../../assets/Logo/whatsapp.svg";
import { FaPhone, FaWhatsapp } from "react-icons/fa";
import { MdPhone } from "react-icons/md";
const Appdevelopment = [
  {
    name: "Mobile App Development",
    routerPath: "/mobile-app-development",
  },
  {
    name: "Iphone App Development",
    routerPath: "/iphone-app-development",
  },
  {
    name: "Android App Development",
    routerPath: "/android-app-development",
  },
  {
    name: "Flutter App Development",
    routerPath: "/flutter-app-development",
  },
  {
    name: "React Native app ",
    routerPath: "/react-native-development",
  },
  {
    name: "Wearable App Development",
    routerPath: "/wearable-development",
  },
  {
    name: "Hybrid App Development",
    routerPath: "/hybrid-development",
  },
  {
    name: "Mobile App Developers",
    routerPath: "/mobile-app-developers",
  },
  {
    name: " App Maintenece Support",
    routerPath: "/app-maintenence-support",
  },
];

const WebDevelopmet = [
  {
    name: "UI and UX Design",
    routerPath: "/webdesign",
  },
  {
    name: "Website Development",
    routerPath: "/web-development",
  },
  {
    name: "PHP Development",
    routerPath: "/php-development",
  },
  {
    name: "Java Development",
    routerPath: "/java-development",
  },
  {
    name: "Angular Development",
    routerPath: "/angular-develoment",
  },
  {
    name: "Ruby  On Rails",
    routerPath: "/ruby-on-rails",
  },
  {
    name: "Ecommerce  Developement",
    routerPath: "/ecommerce-web-development",
  },
  {
    name: "SoftWare Development",
    routerPath: "/software-development",
  },
];

const emerging = [
  
  {
    name: "AR VR Development",
    routerPath: "/ar-vr-development",
  },
  {
    name: "AI ML Development",
    routerPath: "/ai-ml-development",
  },
  {
    name: "IoT Development",
    routerPath: "/iot-development",
  },
  {
    name: "POS Software Development",
    routerPath: "/pos-software-development",
  },
  {
    name: "Web3  Development Company",
    routerPath: "/web3-development",
  },
  {
    name: "AI  Development Company",
    routerPath: "/ai-development-company",
  },
];

const GameDevelopment = [
  {
    name: "Poker App Development",
    routerPath: "/poker-game-development",
  },
  {
    name: "Ludo Game Development",
    routerPath: "/ludo-game-development",
  },
  {
    name: "AR Game Development",
    routerPath: "/ar-game-development",
  },
  {
    name: "Casino Game Development",
    routerPath: "/casino-game-development",
  },

  {
    name: "VR Game Development",
    routerPath: "/vr-game-development",
  },
  {
    name: "Unreal Game Development",
    routerPath: "/unreal-engine-game-development",
  },
  {
    name: "Unity Game Development",
    routerPath: "/unity-game-development",
  },
  {
    name: "Rummy Game Development",
    routerPath: "/rummy-game-development",
  },
  {
    name: "Arcade Game Development",
    routerPath: "/arcade-game-development",
  },
  {
    name: "Bingo Game Development",
    routerPath: "/bingo-game-development",
  },
  
  {
    name: "Board Game Development",
    routerPath: "/board-game-development",
  },
];
const BlockchainDevelopment=[
  {
    name: "Blockchain Game Dev",
    routerPath: "/blockchain-game-development",
  },
  {
    name: "Blockchain App Development",
    routerPath: "/blockchain-app",
  },
]

const Services = [
  {
    name: "RaidenVerse",
    routerPath: "/raiden-verse",
  },
  {
    name: "Raiden Simx",
    routerPath: "/raiden-simx",
  },
  {
    name: "RaidenCogni+",
    routerPath: "/raiden-cogni",
  },
  {
    name: "RaidenArcviz",
    routerPath: "/raiden-arcviz",
  },
];
const Miscellaneous = [
  {
    name: "Clash of Empires",
    routerPath: "/clash-empire",
  },
  {
    name: "Virtual Vegas",
    routerPath: "/virutal-vegas",
  },
  {
    name: "Metaverse Royale",
    routerPath: "/metaverse-royal",
  },
];
const Portfolio = [
  {
    name: "Blog",
    routerPath: "/blog",
  },
  {
    name: "Case Study",
    routerPath: "/case-study",
  },
];
const Blogs = [
  {
    name: "About us",
    routerPath: "/about-us",
  },

  {
    name: "Career",
    routerPath: "/career",
  },
  {
    name: "Contact us",
    routerPath: "/contactus",
  },
];
const Docs = [
  {
    name: "Full Width",
    routerPath: "/doc-full-width",
  },
  {
    name: "Full Width Banner",
    routerPath: "/doc-full-width-banner",
  },
  {
    name: "Doc Box",
    routerPath: "doc-box",
  },
  {
    name: "Doc Box With Banner",
    routerPath: "/doc-box-with-banner",
  },
  {
    name: "Changelog ***",
    routerPath: "/changelog",
  },
];

const MegaMenu = () => {
  return (
    <ul className="navbar-nav ml-nav">
      <li className="nav-item dropdown position-static active text-black">
        <Link className="nav-link text-black " to="/">
          Home
        </Link>
      </li>

      <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
          Services
        </a>
        <ul className="dropdown-menu">
          <li className="dropdown-submenu dropdown">
            <a
              href="#"
              className="dropdown-item dropdown-toggle"
              data-toggle="dropdown"
            >
              Custom App Development
            </a>
            <ul className="dropdown-menu">
              {Appdevelopment.map((val, i) => (
                <li key={i}>
                  <Link to={val.routerPath} className="dropdown-item">
                    {val.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          <li className="dropdown-submenu dropdown" >
            <a
              href="#"
              className="dropdown-item dropdown-toggle"
              data-toggle="dropdown" style={{textTransform:'none'}}
            >
              Web Development
            </a>
            <ul className="dropdown-menu">
              {WebDevelopmet.map((val, i) => (
                <li key={i}>
                  <Link to={val.routerPath} className="dropdown-item">
                    {val.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          <li className="dropdown-submenu dropdown">
            <a
              href="#"
              className="dropdown-item dropdown-toggle"
              data-toggle="dropdown"
            >
              Emerging Technologies
            </a>
            <ul className="dropdown-menu">
              {emerging.map((val, i) => (
                <li key={i}>
                  <Link to={val.routerPath} className="dropdown-item">
                    {val.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          <li className="dropdown-submenu dropdown">
            <a
              href="#"
              className="dropdown-item dropdown-toggle"
              data-toggle="dropdown"
            >
              Game Development
            </a>
            <ul
              className="dropdown-menu overflow-scroll "
              style={{ height: 300 }}
            >
              {GameDevelopment.map((val, i) => (
                <li key={i}>
                  <Link to={val.routerPath} className="dropdown-item">
                    {val.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          <li className="dropdown-submenu dropdown">
            <a
              href="#"
              className="dropdown-item dropdown-toggle"
              data-toggle="dropdown"
            >
              Blockchain Development
            </a>
            <ul
              className="dropdown-menu "
              
            >
              {BlockchainDevelopment.map((val, i) => (
      <li key={i} >
        <Link to={val.routerPath} className="dropdown-item">
          {val.name}
        </Link>
      </li>
    ))}
            </ul>
          </li>
        </ul>
      </li>

      <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
          Products
        </a>

        <ul className="dropdown-menu">
          <li className="dropdown-submenu dropdown">
            <a
              href="#"
              className="dropdown-item dropdown-toggle"
              data-toggle="dropdown"
            >
              XR
            </a>
            <ul className="dropdown-menu">
              {Services.map((val, i) => (
                <li key={i}>
                  <Link to={val.routerPath} className="dropdown-item">
                    {val.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          <li className="dropdown-submenu dropdown">
            <a
              href="#"
              className="dropdown-item dropdown-toggle"
              data-toggle="dropdown"
            >
              Game
            </a>
            <ul className="dropdown-menu">
              {Miscellaneous.map((val, i) => (
                <li key={i}>
                  <Link to={val.routerPath} className="dropdown-item">
                    {val.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </li>

      <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
          Resourses
        </a>
        <ul className="dropdown-menu">
          {Portfolio.map((val, i) => (
            <li key={i}>
              <Link to={val.routerPath} className="dropdown-item">
                {val.name}
              </Link>
            </li>
          ))}
        </ul>
      </li>

      <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
          Company
        </a>
        <ul className="dropdown-menu">
          {Blogs.map((val, i) => (
            <li key={i}>
              <Link to={val.routerPath} className="dropdown-item">
                {val.name}
              </Link>
            </li>
          ))}
        </ul>
      </li>

      <li className="nav-link d-flex align-items-center ms-3 ">
        <a
          href="https://api.whatsapp.com/send?phone=919884036062"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="fs-3" style={{ color: "#25d366" }} />
        </a>
      </li>
      {/* <li className="nav-item dropdown d-flex align-items-center position-relative">
        <a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown">
          <MdPhone className="fs-3" style={{ color: "#f18f27" }} />
        </a>
        <ul className="dropdown-menu dropdown-menu-end">
          <li>
            <p className="opacity-50 mx-4 ">We are just a call away</p>
            <a
              href="tel:+919884036062"
              className="dropdown-item d-flex align-items-center gap-2"
            >
              <span>+91 98840 36062 (Sales)</span>
            </a>

            <a
              href="tel:+919585306437"
              className="dropdown-item d-flex align-items-center gap-2"
            >
              <span>+91 95853 06437 (Hr)</span>
            </a>
          </li>
          <li>
            <p className="opacity-50 mx-4 ">Write us</p>
            <a
              href="tel:+919884036063"
              className="dropdown-item d-flex align-items-center gap-2"
            >
              <span className="d-block" style={{font:"16px",color:'#727272'}}>info@raiden.studio</span>
            </a>
          </li>
        </ul>
      </li> */}
    </ul>
  );
};

export default MegaMenu;
